import { Modal } from "@mui/material"
import { Dispatch, SetStateAction, useEffect, useRef } from "react"
import ActionStateDesktop from "ui/ActionState/ActionStateDesktop"

type ContactUsStateProps = {
  isOpen: boolean
  isSuccess: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  top?: number,
  left?: number,
  center?: boolean
}

function ContactUsState({ isOpen, isSuccess, setIsOpen, top = 200, left = 200, center = false }: ContactUsStateProps) {
  const handleClose = () => setIsOpen(false)
  const modalRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (isOpen && modalRef.current) {
      const focusableElement = modalRef.current.querySelector("button")
      focusableElement?.focus()
    }
  }, [isOpen])
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="contact-state-title"
    >
      <div ref={modalRef} role="alertdialog" aria-labelledby="contact-state-title">
        <ActionStateDesktop
          title={isSuccess ? "פנייתך נשלחה בהצלחה" : "פנייתך נכשלה, מצטערים"}
          titleId="contact-state-title"
          image={isSuccess ? "/images/success.png" : "/images/Failed2.png"}
          buttonText={isSuccess ? "חזרה" : "ניסיון נוסף"}
          width={640}
          imageWidth={580}
          imageHeight={400}
          top={top}
          left={left}
          handleClose={handleClose}
          buttonAction={handleClose}
          center={center}
        />
      </div>
    </Modal>
  )
}

export default ContactUsState
